import React from 'react';
import Reflux from 'reflux';
import { hashHistory } from 'react-router';
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  message,
} from 'antd';
import {
  DmsTab,
  MyUpload,
} from 'Components';
import {
  dataitemAdd,
  dataitemModify,
  dataitemDetail,
  dataitemList,
} from '../../service/dictionary/dataitem.js';
import { dictionayDetail } from '../../service/dictionary';
import { nameValidator } from '../../utils/regexp.js';
import {
  showSpin,
  hideSpin,
  config,
} from 'Utils';
import {
	dictionaryStore,
	dictionaryActions,
} from './store';

const Option = Select.Option;
const FormItem = Form.Item;
const { TextArea } = Input;

class DictionaryAdditem extends Reflux.Component {
  constructor(props) {
    super(props);
    this.store = dictionaryStore;
    this.state = {
      opts: ['新建数据项值'],
      detail: {},
      addStr: this.props.params.additemId,
      additemId: null,
      allFlag: true,
      itemId: null,
      disabled: false,
      dependentArr: [],
    };
    this.checkSkey = this.checkSkey.bind(this);
    this.goView = this.goView.bind(this);
    this.checkSortOrder = this.checkSortOrder.bind(this);
  }

  componentDidMount() {
    var addArr = this.state.addStr.split('-');
    //编辑
    if (addArr.length == 2) {
      this.setState({
        opts: ['编辑数据项值'],
        disabled: true,
      });
      var detailArr = addArr[0].split('+');
      dataitemDetail({ id: parseInt(detailArr[0], 0) }).then(result => {
        if (result.status) {
          result.data.dictionaryValue = addArr[1];
          let fileObj = [];
          if(!!result.data.picId && !!result.data.filePath) {
						fileObj = [
							{
								id: result.data.picId,
								uid: -1,
								name: '',
								status: 'done',
								url: `${config.server}${result.data.filePath}`,
								thumbUrl: `${config.server}${result.data.filePath}`,
							},
						];
					}
          if (result.data.dependentDataItemId) {
            dataitemList({ id: parseInt(detailArr[1], 0) }).then(last => {
              if (last.status) {
                if (last.data != null) {
                  this.setState({
                    dependentArr: last.data,
                    detail: {
											...result.data,
											fileObj
										},
                    allFlag: false,//决定从属数据项是否显示
                  });
                } else {
                  this.setState({
                    detail: {
                    	...result.data,
											fileObj
										},
                    allFlag: false,//决定从属数据项是否显示
                  });
                }
              } else {
                message.error(last.message);
              }
            });
          } else {
            this.setState({
              detail: {
                ...result.data,
                fileObj,
              },
              allFlag: true,//决定从属数据项是否显示
            });
          }
        } else {
          message.error(result.message);
        }
      });
    }
    ;
    //新增
    if (addArr.length == 3) {
      var allFlag = null;
      if (addArr[2] == false) {
        allFlag = false;
      } else {
        allFlag = true;
      }
      this.setState({
        disabled: false,
        additemId: addArr[0],
        allFlag,
        itemId: addArr[1],
      });
      var obj = {};
      obj.id = parseInt(addArr[0], 0);
      dictionayDetail(obj).then(result => {
        if (result.status) {
          let fileObj = [];
					if(!!result.data.picId && !!result.data.filePath) {
						fileObj = [
							{
								id: result.data.picId,
								uid: -1,
								name: '',
								status: 'done',
								url: `${config.server}${result.data.filePath}`,
								thumbUrl: `${config.server}${result.data.filePath}`,
							},
						];
					}
          var dataObj = {};
          if (addArr[2] == 'false') {
            dataObj.dictionaryId = result.data.id;
            dataObj.dictionaryValue = result.data.name;
            var dependentId = result.data.dependentDataItemId;
            dataObj.dependentDataItemId = parseInt(addArr[1], 0);
            dataitemList({ id: dependentId }).then(last => {
              if (last.status) {
                if (last.data != null) {
                  this.setState({
                    dependentArr: last.data,
                    detail: {
											...dataObj,
											fileObj,
										},
                    allFlag: false,//决定从属数据项是否显示
                  });
                } else {
                  this.setState({
                    detail: {
											...dataObj,
											fileObj,
										},
                    allFlag: false,//决定从属数据项是否显示
                  });
                }
              } else {
                message.error(last.message);
              }
            });
          } else {
            var dictionaryObj = {};
            dictionaryObj.id = result.data.id;
            this.setState({
              detail: {
								...dictionaryObj,
								fileObj,
							},
              allFlag: true,//决定从属数据项是否显示
            });
          }
        } else {
          message.error(result.message);
        }
      });
    }
  }

  cancelHandle() {
    hashHistory.goBack();
  }

  goView(url) {
    hashHistory.push(url);
  }

  submitHandle() {
    const { detail, allFlag, additemId, itemId } = this.state;
    const { validateFields, getFieldValue } = this.props.form;
    validateFields((errors, values) => {//表单校验
      if (errors) {
        return;
      }//表单校验有误，则不执行下面的代码
      //传向接口
      var dataobj = {};
      if (getFieldValue('active') === '1') {
        dataobj.active = 1;
      } else {
        dataobj.active = 0;
      }
      dataobj.sortOrder = parseInt(values.sortOrder, 10);
      dataobj.description = values.description; //getFieldValue('description');
      dataobj.name = values.name; //getFieldValue('name');
      dataobj.picId = values.fileObj && values.fileObj.length ? values.fileObj[0].id : '';
      dataobj.filePath = values.fileObj && values.fileObj.length ? values.fileObj[0].url.replace(/http(s)?:\/\/\S+\/xweb\//, '') : ''; // http://36.22.191.179:8180/xweb
      //fileObj
      //新增
      showSpin();
      if (additemId) {
        if (allFlag == false) {
          dataobj.dependentDataItemId = parseInt(itemId, 0);
          dataobj.dictionaryId = detail.dictionaryId;
        } else {
          dataobj.dependentDataItemId = 0;
          dataobj.dictionaryId = detail.id;
        }
        dataobj.sKey = getFieldValue('sKey');
        dataitemAdd(dataobj).then(data => {
          hideSpin();
          if (data.status) {
            message.success(data.message);
            this.goView(`/dictionary/detail/${dataobj.dictionaryId}`);
          } else {
            message.error(data.message);
          }
        });
      } else {//编辑
        if (allFlag == false) {
          dataobj.dependentDataItemId = parseInt(getFieldValue('dependentDataItemId'), 0);
          dataobj.dictionaryId = detail.dictionaryId;
        } else {
          dataobj.dependentDataItemId = 0;
          dataobj.dictionaryId = detail.dictionaryId;
        }
        dataobj.sKey = detail.sKey;
        dataobj.id = detail.id;
        dataitemModify(dataobj).then(data => {
          hideSpin();
          if (data.status) {
            message.success(data.message);
            this.goView(`/dictionary/detail/${dataobj.dictionaryId}`);
          } else {
            message.error(data.message);
          }
        });
      }
    });
  }

  //获取从属数据项值
  getDependentItemValue(value) {
    this.setState({
      itemId: parseInt(value, 0),
    });
    dictionaryActions.dependentChange(parseInt(value, 0));
  }

  //skey正则
  checkSkey(rule, value, callback) {
    const vaReg = /^(?!_)(?!.*?_$)\w{1,50}$/;
    if (value) {
      if (!(vaReg.test(value))) {
        callback('请输入1-50位的数字、字母或下划线,但不可用下划线开头和结尾');
      }
      callback();
    }
    callback();
  }

  //排序正则
  checkSortOrder(rule, value, callback) {
    const vaReg = /^\d{1,}$/;
    if (value) {
      if (!(vaReg.test(value))) {
        callback('排序只可输入整数');
      }
      callback();
    }
    callback();
  }

  render() {
    const { opts, detail, allFlag } = this.state;
    const { getFieldDecorator } = this.props.form;
    const myUploadProps = {
      maxWidth: 120,
      maxHeight: 120,
      maxSize: 1,
      maxCount: 1,
      antdUploadProps: {
        listType: 'picture',
        showUploadList: { showRemoveIcon: true },
      },
    };
    return <div className='dms-body'>
      <DmsTab options={opts} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box" style={{ backgroundColor: '#fff' }}>
        <Form layout="horizontal">
          {
            allFlag ?
              ''
              :
              <Row gutter={16}>
                <Col className="gutter-row" span={12}>
                  <FormItem label="从属数据项">
                    {getFieldDecorator('dictionaryId', {
                      initialValue: (detail !== null && detail.dictionaryValue) ? detail.dictionaryValue : '',
                    })(<Input disabled={true} />)}
                  </FormItem>
                </Col>
                <Col className="gutter-row" span={12}>
                  <FormItem label="从属数据项值">
                    {getFieldDecorator('dependentDataItemId', {
                      initialValue: (detail !== null && detail.dependentDataItemId) ? detail.dependentDataItemId.toString() : '',
                      rules: [
                        {
                          required: true,
                          message: '请选择从属数据项值',
                        },
                      ],
                    })(<Select
                      onChange={this.getDependentItemValue.bind(this)}
                      placeholder='请选择从属数据项'
                    >
                      {
                        this.state.dependentArr.map(function (item, key) {
                          return <Option value={(item.id).toString()}
                                         key={key}>{item.name}</Option>;
                        })
                      }
                    </Select>)}
                  </FormItem>
                </Col>
              </Row>
          }
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="数据项值Key">
                {getFieldDecorator('sKey', {
                  initialValue: (detail !== null && detail.sKey) ? detail.sKey : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入数据项值Key',
                    },
                    {
                      validator: this.checkSkey,
                    },
                  ],
                })(<Input placeholder="请输入数据项值Key,保存后不可修改" disabled={this.state.disabled} />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="数据项值名称">
                {getFieldDecorator('name', {
                  initialValue: (detail !== null && detail.name) ? detail.name : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入数据项值名称',
                    },
                    {
                      validator: nameValidator,
                    },
                  ],
                })(<Input placeholder="请输入数据项值名称" />)}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <FormItem label="描述">
              {getFieldDecorator('description', {
                initialValue: (detail !== null && detail.description) ? detail.description : '',
              })(<TextArea rows={4} />)}
            </FormItem>
          </Row>

          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="状态">
                {getFieldDecorator('active', {
                  initialValue: (detail !== null && detail.active === 0) ? '0' : '1',
                  rules: [
                    {
                      required: true,
                      message: '请选择状态',
                    },
                  ],
                })(<Select>
                  <Option value='1'>启用</Option>
                  <Option value='0'>禁用</Option>
                </Select>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="排序">
                {getFieldDecorator('sortOrder', {
                  initialValue: (detail !== null && detail.sortOrder) ? detail.sortOrder : '',
                  rules: [
                    {
                      validator: this.checkSortOrder,
                    },
                  ],
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
          <FormItem
            className="mt20"
            label="对应图片"
            extra={<small>建议图片大小：120x120px；图片格式jpg、png、jpeg；图片大小小于1M</small>}
          >
            {getFieldDecorator('fileObj', {
              initialValue: detail.fileObj || [],
              rules: [
                {
                  required: false,
                  message: '请上传商品缩略图',
                },
              ],
            })(
              <MyUpload {...myUploadProps}>
                <Button icon="upload">点击上传</Button>
              </MyUpload>,
            )}
          </FormItem>
        </Form>
      </div>
    </div>;
  }
}

export default Form.create()(DictionaryAdditem);



// WEBPACK FOOTER //
// ./src/routes/dictionary/additem.js